export default __webpack_public_path__ + "static/media/Table-Appstore.392e9235.svg";